import React, { Fragment } from 'react'
import { H3, P, Icon, Div, Button } from '@drifthq/tide-core'
import isMobile from 'ismobilejs'
import config from 'config'

import MOBILE_ILLUSTRATION_SRC from './mobile-illustration.png'
import DESKTOP_ILLUSTRATION_SRC from './desktop-illustration.png'
import APP_STORE_SRC from './app-store.svg'
import boltTrioPink from '../VideoInstallStep/bolt-trio-pink.svg'

import './style.css'

const AppleContent = () => (
  <Fragment>
    <img
      className="touchless-video-apple-illustration"
      src={MOBILE_ILLUSTRATION_SRC}
      alt="mobile_illustration"
    />
    <H3 className="touchless-video-header">Get the Drift mobile app</H3>
    <P className="touchless-video-copy">Record and share your videos with anyone, from anywhere.</P>
    <a href={`https://itunes.apple.com/us/app/drift-messaging-for-sales/id1117096112?ls=1&mt=8`} target="_blank">
      <img className="touchless-video-app-store" src={APP_STORE_SRC} alt="app_store" />
    </a>
  </Fragment>
)

const AndroidContent = () => (
  <Fragment>
    <img
      className="touchless-video-android-illustration"
      src={DESKTOP_ILLUSTRATION_SRC}
      alt="desktop_illustration"
    />
    <H3 className="touchless-video-header">Finish setting up your Drift account at your computer</H3>
    <P className="touchless-video-copy">
      We just sent you an email with a link to your Drift account. See you soon!{' '}
    </P>
  </Fragment>
)

const ChromeContent = ({ name }) => (
  <Div className="video-install-container">
    <Div className="drift-getting-started">
      <Div className="drift-install-content">
        <img className="drift-bolt-trio-left" src={boltTrioPink} alt="bolts-pink" />
        <Div className="drift-getting-started-microcopy">Welcome{name && `, ${name}`}!</Div>
        <H3 className="drift-getting-started-title">
          Nice job adding Drift Video to Chrome.&nbsp;
          <span>Now go back and record your first video!</span>&nbsp;
        </H3>
        <Button href={config.DRIFT_VIDEO_URL} className="drift-install-success-CTA">Continue to dashboard</Button>
      </Div>
    </Div>
  </Div>
)

const VideoSuccessStep = ({ name }) => {
  let Content
  if (isMobile.apple.device) {
    Content = AppleContent
  } else if (isMobile.android.device) {
    Content = AndroidContent
  } else {
    Content = ChromeContent
  }
  return (
    <Div className="touchless-video-container">
      <Icon name="drift-logo-round" className="video-logo-container-mobile" />
      <Content name={name}/>
    </Div>
  )
}

export default VideoSuccessStep



// WEBPACK FOOTER //
// ./src/layouts/VideoSuccessStep/component.js